module.exports = __webpack_public_path__ + "img/772456a.jpg";